import React from "react";
import { Header } from "../../../components/Header";
import { JoinusBanner } from "../../../blocks/joinus-banner";
import { JoinusJob } from "../../../blocks/joinus-job";
import "./styles.less";
// import { JoinusWork } from "../../../blocks/joinus-work";
import { JoinusExperience } from "../../../blocks/joinus-experience";
import { Footer } from "../../../components/Footer";
// import { WorldCloud } from "../../../components/WordCloud";

export const JobList = () => {
  return (
    <div className="job-list">
      <Header mode={"light"} />
      <JoinusBanner />
      <JoinusExperience />
      {/* <WorldCloud /> */}
      {/* <JoinusWork /> */}
      <JoinusJob />
      <Footer />
    </div>
  );
};
